import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

export function CountdownDisplay({ label, targetAt }) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick((x) => x + 1), 1000);
    return () => clearInterval(id);
  }, []);

  if (!targetAt) return null;

  const target = new Date(targetAt).getTime();
  const diff = Math.max(0, target - Date.now());
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  const units = [
    [days, "days"],
    [hours, "hrs"],
    [minutes, "min"],
    [seconds, "sec"],
  ];

  return (
    <div className="flex flex-col gap-space-12 rounded-radius-lg bg-bg-raised p-space-16">
      <p className="text-caps-label uppercase text-accent-text">{label}</p>
      <div className="flex items-center gap-space-16">
        {units.map(([value, unit]) => (
          <div key={unit} className="flex flex-col items-center">
            <span className="text-title-1 tabular-nums text-label-primary">{pad(value)}</span>
            <span className="text-caption-1 text-label-secondary">{unit}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
